import React, { useEffect } from "react";
import { Modal, Button, Header } from "semantic-ui-react";
import "./BoxErrorModal.css";
import WithEventWarning from "../WithEventWarning/WithEventWarning";
import SharedFunctions from "../../utils/SharedFunctions";
import { BOX_ERROR_MODAL } from "../../utils/constants/componentConstants";

const BoxErrorModal = ({ open, onClose, message, header, className }) => {
  useEffect(() => {
    function onOpen() {
      SharedFunctions.LogPopupShownEvent(BOX_ERROR_MODAL);
    }
    if (open) {
      onOpen();
    }
  }, [open]);

  return (
    <Modal
      open={open}
      size="small"
      className={"BoxErrorModal " + className}
      closeOnEscape={false}
      closeOnDimmerClick={false}
    >
      <Header icon="warning sign" color="red" content={header} />
      <Modal.Content>
        <h1>{message}</h1>
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={onClose}>
          Okej
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default WithEventWarning(BoxErrorModal);
